import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PrintTicketComponent } from '../print-ticket/print-ticket.component';
import { ToolsService } from 'src/app/services/tools.service';
import { BillService } from 'src/app/services/bill.service';

@Component({
  selector: 'app-tickets-detail',
  templateUrl: './tickets-detail.component.html',
  styleUrls: ['./tickets-detail.component.scss'],
})
export class TicketsDetailComponent implements OnInit {

  @Input() contest: any;
  @Input() generatedTickets: any;

  constructor(private modalCtrl: ModalController, private toolsService: ToolsService, private billService: BillService) {
  }

  ngOnInit() {
    console.log('Contest', this.contest);
    console.log('GeneratedTickets', this.generatedTickets);

    // Set all not printed tickets as selected
    this.generatedTickets.forEach((ticket: any) => {
      if (!ticket.printed) ticket.selected = true;
      else ticket.selected = false;
    });
    // Order tickets by date desc
    this.generatedTickets.sort((a: any, b: any) => {
      return new Date(b.created).getTime() - new Date(a.created).getTime();
    });

    console.debug('GeneratedTickets', this.generatedTickets);

  }

  get anyTicketSelected() {
    return this.generatedTickets.some((ticket: any) => ticket.selected);
  }

  async printTickets() {
    const ticketsToPrint = this.generatedTickets.filter((ticket: any) => ticket.selected);
    await this.toolsService.showLoading('Imprimiendo tickets...');
    await this.updatePrintedTickets(ticketsToPrint);
    await this.toolsService.hideLoading();
    const modal = await this.modalCtrl.create({
      component: PrintTicketComponent,
      componentProps: {
        tickets: ticketsToPrint, contest: this.contest
      }
    });
    modal.present();
  }


  async updatePrintedTickets(ticketsToPrint: any) {
    let promises: Array<Promise<any>> = [];
    ticketsToPrint.forEach(async (ticket: any) => {
      promises.push(
        this.toolsService.convertObservableToPromise(this.billService.setTicketPrinted(ticket.id))
      )
    });
    try {
      let result = await Promise.all(promises);
      console.debug('Tickets updated', result);
    } catch (err) {
      console.error("error updating ticket", err);
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
